export default {"src":"/_next/static/media/twitter.0b18ca1a.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};